import { useState, useEffect } from "react";
import { ExpandedContent, Separator } from "./styles";
import { IItemHistorico } from "../../../../types";
import { DadosProfissionalAtribuido } from "./types";
import { mapearDadosProfissionalAtribuido } from "./utils";
import BlocoPrincipal from "./Blocos/BlocoPrincipal/index";
import LogsVazio from "../../Compartilhado/LogsVazio";
import api from "../../../../../../../services/api";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentProfissionalAtribuido({ item }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosProfissionalAtribuido | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item.id) {
            setLoading(false);
            return;
        }

        const buscarDados = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === 'success') {
                    const logs = response.data.result || [];
                    const dadosProcessados = mapearDadosProfissionalAtribuido(logs);
                    setDados(dadosProcessados);
                }
            } catch (error: any) {
                console.error('Erro ao buscar dados do histórico:', error);
                setDados(null);
            } finally {
                setLoading(false);
            }
        };

        buscarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados || dados.campos.length === 0) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoPrincipal campos={dados.campos} />
        </ExpandedContent>
    );
}

